import ViewActionsService from 'app/actions/view.actions';
import NewBookingActionsService from "app/actions/newBooking.actions";
import { STATUS_CHANGE } from "app/actions/networkConnection.actions";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import CustomerOfflineSyncService from "external-services/customer-offline-sync-service/customerOfflineSync.service";
import BookingLookupService from "external-services/booking-lookup-service/index";
import { BookingMethods } from 'shared-types/index';
import BookingsUtilsService from 'app/services/bookingsUtils/bookingsUtils.service';
import DateUtilsService from 'external-services/date-utils-service';
import VenueActions, { VenueActionNames } from "app/actions/venue.actions";
import PouchLoadService from "external-services/pouch-load-service";
import { CouchStatus } from "app/app.types";
import { cloneDeep } from "lodash-es";
import ManagerService from "external-services/manager-service/manager.service";
import { isBookingCreator } from "app/reducers/settings/slice";
import store from "appRoot/Store";
import { IntlService } from 'external-services/intl-service';
import { openGlobalSearchModal } from 'app/reducers/globalSearchModal/slice';
// requiring html templates so that hot reloading works
const newBookingTemplate = require('app/bookings/new/newBooking.html');
const editBookingTemplate = require('app/bookings/edit/editBooking.html');

const NS = 'MainCtrl'; // jshint ignore:line

export default function MainCtrl(
  $scope, $rootScope, $mdDialog, $element, pouchService,
  AppEventService, appConstants, $interval, $window
) {
  "ngInject";

  const vm = this;

  var dialogOpen = false;

  let handleStatusChangeTO;
  let handleStatusChangeAttempts = 0;

  vm.title = 'Now Book It';
  vm.isOnline = NetworkConnectionService.isOnline();
  vm.reloadDialogDismissCount = 0;

  $rootScope.$on('new-booking', newBooking);
  $rootScope.$on('new-booking-type-select', typeSelect);
  $rootScope.$on('edit-booking', editBooking);
  $rootScope.$on('status-edit', statusEdit);
  // $rootScope.$on('venue-change', venueChange);
  VenueActions.handleVenueAction(VenueActionNames.VENUE_CHANGE, () => venueChange())
  $rootScope.$on('venue-loaded', venueChange);
  $rootScope.$on('reload-needed', reloadNeeded);
  $rootScope.$on('new-version', newVersion);
  $rootScope.$on('login', venueChange);
  $rootScope.$on('unauthorised', unauthorised);

  AppEventService.on('openNotes', openNotes);
  AppEventService.on('openGlobalSearch', openGlobalSearch);
  AppEventService.on('managePreAuth', managePreAuth);
  AppEventService.on('bookingMoved', bookingMoved);
  AppEventService.on('newBooking', (data, targetEvt) => {
    newBooking({}, targetEvt, data.date, data.table, data.bookingMethod, data.bookingToMove, data.customer, data.bookingDuration, data.selectedService);
  });

  // init
  venueChange();




  $interval(callAtInterval, 1000);

  // moved to setTimeout to prevent handling status change before all files have loaded properly
  handleStatusChange();

  function handleStatusChange() {
    handleStatusChangeAttempts += 1;
    if (handleStatusChangeTO) {
      clearTimeout(handleStatusChangeTO);
    }
    if (PouchLoadService.getDbLocal()) {
      statusUpdate(true);
      $rootScope.$on(STATUS_CHANGE, () => statusUpdate(false));
    } else {
      if (handleStatusChangeAttempts < 5) {
        // if not ready yet, try again in 2 seconds
        handleStatusChangeTO = setTimeout(() => handleStatusChange(), 2000);
      } else {
        console.warn(NS, `Handler for '${STATUS_CHANGE}' gave up due to too many attempts on 'PouchLoadService.getDbLocal'`);
      }
    }
  }

  function venueChange() {
    var venue = AdminService.getVenue();
    if (venue) {
      vm.title = venue.name;

      const account = AdminService.getAccount();
      if (account) {
        ManagerService.setValuesFromAccountData(account.roles);
      }
    }
  }

  function bookingMoved(newBooking) {
    vm.movedBooking = newBooking; // The new booking Object obtained from the newBooking.controller
  }


  function callAtInterval() {

    var setting = null;
    GeneralSettingsService.get().then(function (s) {
      setting = s;

      const timezoneId = AdminService.getVenueTimezoneId();
      let midnight = DateUtilsService.getVenueTime(timezoneId);
      midnight.setDate(midnight.getDate());
      midnight.setHours(23, 59, 59, 0);
      var venus = DateUtilsService.getVenueTime(timezoneId);

      if (midnight.getTime() == venus.getTime() && s.diaryRollover && s.diaryRollover === true) {
        $window.location.reload();  // could just set it to go to the next page via the picker but would be a lot more work.
      }
    });
  }

  function typeSelect(evt, targetEvt, date, table) {
    const timezoneId = AdminService.getVenueTimezoneId();
    var tomorrow = DateUtilsService.getClearDate(null, timezoneId);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (date < tomorrow) {
      $mdDialog.show({
        controller: 'TypeSelectCtrl',
        controllerAs: 'vm',
        locals: {
          bookDate: date,
          bookTable: table,
        },
        clickOutsideToClose: true,
        templateUrl: 'app/bookings/typeSelect/typeSelect.html',
        targetEvent: targetEvt,
        onShowing: function () {
          dialogOpen = true;
        },
        onRemoving: function () {
          dialogOpen = false;
        }
      });
    } else {
      newBooking(evt, targetEvt, date, table);
    }
  }

  function editBooking(evt, targetEvt, bookingImmutable, skipOriginal) {

    if (!skipOriginal) {
      // keep a record of the original booking unless instructed to skip it
      BookingsUtilsService.setEditBookingOriginal(cloneDeep(bookingImmutable));
    }

    /**
     * bookingImmutable will not actually be immutable if coming from AngularJS, but will be if coming from Redux,
     * so we assume here that it needs to be copied to avoid Object extensible issues.
     */
    const bookingMutable = cloneDeep(bookingImmutable);

    BookingLookupService.getById(bookingMutable._id, bookingMutable.time)
      .then((booking) => {
        if (isBookingCreator()) {
          ViewActionsService.onEditBookingOpened({
            booking: bookingMutable,
          });
          dialogOpen = true;
          $mdDialog.hide();
          ViewActionsService.handleEditBookingClosed(() => {
            dialogOpen = false;
          });
          return;
        } else {
          $mdDialog.show({
            controller: 'EditBooking',
            controllerAs: 'editBooking',
            locals: {
              booking: booking,
              element: $element
            },
            template: editBookingTemplate,
            targetEvent: targetEvt,
            onComplete: function ($scope) {
              $scope.editBooking.showComplete = true;
              $scope.$onInit();
            },
            onShowing: function () {
              dialogOpen = true;
            },
            onRemoving: function ($scope) {
              console.log(NS, 'closed edit booking', $scope)
              dialogOpen = false;
            }
          })
        }   
      });
  }


  function statusEdit(evt, targetEvt, booking, schedule) {
    $mdDialog.show({
      controller: 'StatusBookingEditorCtrl',
      controllerAs: 'vm',
      locals: {
        booking: booking,
        schedule: schedule
      },
      onComplete: function ($scope) {
        $scope.$onInit();
      },
      targetEvent: targetEvt,
      clickOutsideToClose: true,
      parent: angular.element(document.body),
      templateUrl: 'app/bookings/statusEditor/statusBookingEditor.html'
    });
  }

  function newVersion() {
    if (!dialogOpen) {
      $mdDialog.show({
        controller: 'AppUpdateDialogCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/common/appUpdate/appUpdateDialog.html',
        parent: angular.element(document.body),
        locals: {
          dismissCount: vm.reloadDialogDismissCount,
          appConstants: appConstants,
        },
        clickOutsideToClose: true,
        onShowing: function () {
          dialogOpen = true;
        },
        onRemoving: function () {
          dialogOpen = false;
        }
      });
      vm.reloadDialogDismissCount++;
    }
  }

  function reloadNeeded(event, args) {
    pouchService.destroyDatabases(false, args.venueId);
    if (dialogOpen) {
      $mdDialog.hide();
    }
    $mdDialog.show({
      controller: 'AppReloadDialogCtrl',
      templateUrl: 'app/common/appReload/appReloadDialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      onShowing: function () {
        dialogOpen = true;
      },
      onRemoving: function () {
        dialogOpen = false;
      }
    });
  }

  /**
   * open a new booking window
   */
  function newBooking(evt, targetEvt, date, table, bookingMethod, bookingToMove, customer, bookingDuration, selectedService) {
    bookingMethod = (bookingMethod) ? bookingMethod : BookingMethods.phone;
    const newBookingData = {
      bookDate: date,
      bookTable: table,
      bookingMethod,
      bookingToMove,
      bookingDuration,
      customer,
      selectedService,
    };

    if (isBookingCreator()) {
      NewBookingActionsService.onNewBookingOpened(newBookingData);
      dialogOpen = true;
      $mdDialog.hide();
      NewBookingActionsService.handleNewBookingClosed(() => {
        dialogOpen = false;
      });
      return;
    }

    $mdDialog.show({
      controller: 'NewBooking',
      controllerAs: 'bookingNew',
      locals: {
        ...newBookingData,
        element: $element,
      },
      template: newBookingTemplate,
      targetEvent: targetEvt,
      onComplete: function ($scope) {
        $scope.bookingNew.showComplete = true;
        $scope.$onInit();
      },
      onShowing: function () {
        dialogOpen = true;
      },
      onRemoving: function () {
        dialogOpen = false;
        NewBookingActionsService.onNewBookingClosed();
      }
    });
  }

  function openGlobalSearch(date, targetEvt) {
    store.dispatch(openGlobalSearchModal({ filterDate: date }));
  }

  function unauthorised() {

    $mdDialog.show({
      controller: 'UnauthorisedDialogCtrl',
      templateUrl: 'app/common/unauthorised/unauthorisedDialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      onShowing: function () {
        dialogOpen = true;
      },
      onRemoving: function () {
        dialogOpen = false;
      }
    });
  }

  function openNotes(evt, targetEvt) {
    $mdDialog.show({
      controller: 'NotesCtrl',
      controllerAs: 'vm',
      targetEvent: targetEvt,
      templateUrl: 'app/common/notes/notes.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      locals: {
        date: evt.date
      },
      onShowing: function () {
        dialogOpen = true;
      },
      onRemoving: function () {
        dialogOpen = false;
      }
    });
  }

  function managePreAuth(booking, targetEvt) {

    const { paymentReducer, venueReducer } = store.getState();

    if (paymentReducer?.preAuthDialog) {
      // if using redux paymentReducer.preAuthDialog to show the newer dialog, don't show the old angular version
      return;
    }

    // If normal manage pre auth, targetEvt will be true, then we take the normal booking || we take the moved booking which contains the new booking id for PreAuth
    const preAuthBooking = targetEvt ? booking : vm.movedBooking || booking;
    $mdDialog.show({
      controller: 'PreAuthDialogCtrl',
      controllerAs: 'vm',
      targetEvent: targetEvt,
      templateUrl: 'app/bookings/preAuth/preAuthDialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
        locals: {
        booking: preAuthBooking,
        currencySymbol: IntlService.getCurrencySymbol(venueReducer.currency).symbol,
        currencyCode: venueReducer.currency,
      },
      onShowing: function () {
        dialogOpen = true;
      },
      onRemoving: function () {
        dialogOpen = false;
        vm.movedBooking = null; // Removing the movedBooking once the dialog closes. We dont need that anymore.
      }
    });
  }


  function statusUpdate(skipWasOnlineCheck) {
    const wasOnline = vm.isOnline;
    vm.isOnline = NetworkConnectionService.isOnline();

    const currentCouchStatus = NetworkConnectionService.getCouchStatus();
    if (!vm.isOnline && currentCouchStatus.connection === CouchStatus.sending && currentCouchStatus.localChanges > 0) {
      // offline changes detected
      CustomerOfflineSyncService.setHasPendingOfflineChanges(true);
    }

    if (currentCouchStatus.connection === CouchStatus.uptodate) {
      // offline changes detected
      CustomerOfflineSyncService.setHasPendingOfflineChanges(false);
    }

    if (skipWasOnlineCheck || (!wasOnline && vm.isOnline)) {
      CustomerOfflineSyncService.startSyncingOfflineCustomers();
    } // from offline to online
  }
}
